<template>
  <div>
    <div class="row">
      <div class="col-sm-7">
        <Hero>
          <h2 class="mr-4">
            {{ $t('message.testDrive.importantFeaturesHeader') }}
            <img :src="require('@/assets/fa/star.png')" width="22" height="22" class="mb-2" alt="" />
          </h2>
          <template slot="description">{{ $t('message.testDrive.importantFeaturesDescription') }}</template>
        </Hero>
        <MobialisCheckBoxButton
          :options="features"
          name="important-features"
          v-model="setImportantFeatures"
          data-cy="featuresOptions"
        />
      </div>
      <div class="col-sm-5">
        <DriveTip class="mt-4 mt-sm-2 tip-container">
          <template slot="description">{{ $t('message.testDrive.importantFeaturesDriveTip') }}</template>
        </DriveTip>
      </div>
    </div>
    <mobialis-button class="mt-3 mt-sm-5" @click="submit" data-cy="continueBtn">{{
      $t('message.common.continue')
    }}</mobialis-button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Hero from '@/components/test-drive/Hero.vue';
import DriveTip from '@/components/test-drive/DriveTip.vue';

export default {
  name: 'ImportantFeatures',
  components: {
    Hero,
    DriveTip,
  },
  data() {
    return {
      features: this.$t('message.testDrive.importantFeaturesArray'),
      response: null,
      counter: 0,
    };
  },
  computed: {
    ...mapGetters('testDrive', ['isFromHomeRoute']),
    setImportantFeatures: {
      get() {
        return this.$store.state.testDrive.importantFeatures ? this.$store.state.testDrive.importantFeatures : [];
      },
      set(selected) {
        this.$store.commit('testDrive/SET_IMPORTANT_FEATURES', selected);
      },
    },
    beverageOptions() {
      return this.$store.state.testDrive.settings.beverageOptions;
    },
  },
  methods: {
    submit() {
      if (this.beverageOptions.length > 0 && !this.isFromHomeRoute) {
        this.$router.push({
          name: `drive-beverage-choice-${this.baseRoute}`,
        });
      } else {
        this.$router.push({
          name: `drive-personal-information-${this.baseRoute}`,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
